export default "__VITE_ASSET__Bme2UHM9__"